import { memo, useCallback, useMemo, useState } from 'react'
import { Gifters } from './components/gifters'
import { GiftsContainer } from './components/gifts-container'
import { GiftsTypes } from './components/gifts-types'
import { TotalValue } from './components/total-value'

export const ModalGifts = memo(() => {
  const [isPackageSelected, setIsPackageSelected] = useState(false)

  const token = useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    return params.get('token') ?? localStorage.getItem('@token')
  }, [])

  const handleTogglePackageSelected = useCallback(() => {
    setIsPackageSelected((prevState) => !prevState)
  }, [setIsPackageSelected])

  return (
    <div className="flex flex-col flex-1 overflow-hidden bg-[#151515] rounded-t-xl">
      <div className="h-screen flex flex-col p-4 pb-0 bg-[#151515] rounded-t-xl ">
        <Gifters
          isPackageSelected={isPackageSelected}
          handleTogglePackageSelected={handleTogglePackageSelected}
        />

        <GiftsTypes
          token={token}
          isPackageSelected={isPackageSelected}
          handleTogglePackageSelected={handleTogglePackageSelected}
        />

        <GiftsContainer token={token} isPackageSelected={isPackageSelected} />

        <TotalValue />
      </div>
    </div>
  )
})
